import { render, staticRenderFns } from "./MasterData.vue?vue&type=template&id=e97b4608"
import script from "./MasterData.vue?vue&type=script&lang=ts"
export * from "./MasterData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports